import { Component, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SvgIconComponent } from 'app/shared/components/svg-icon/svg-icon.component';
import { ImageComponent } from '../../../shared/components/image/image.component';

import { ISvgConfig } from 'app/shared/interfaces/svg.interfaces';
import { IPresetImages, IPresetData } from 'app/interfaces/image-generation.interfaces';

import { ESvgTypes } from 'app/shared/enums/svg.enums';
import { EImageUsage } from 'app/shared/enums/image-usage.enums';

import { IMAGE_PRESETS } from 'app/shared/const/image-presets.data';

@Component({
  selector: 'stxt-image-presets',
  standalone: true,
  imports: [CommonModule, SvgIconComponent, ImageComponent],
  templateUrl: './image-presets.component.html',
  styleUrl: './image-presets.component.scss'
})
export class ImagePresetsComponent {
  @Output() selectedPresetPrompt: EventEmitter<IPresetData> = new EventEmitter<IPresetData>();

  presetList: string[] = ['Scene', 'Activity', 'Outfit', 'Accessories', 'Pose'];
  selectedPreset: string = 'Scene';
  addIcon: ISvgConfig = { fill: ESvgTypes.Filled, name: 'add' };
  doneIcon: ISvgConfig = { fill: ESvgTypes.Filled, name: 'done' };
  selectedImages: Set<string> = new Set();
  images: IPresetImages = IMAGE_PRESETS;

  protected readonly EImageUsage = EImageUsage;

  onPresetClick(preset: string): void {
    if (this.selectedPreset === preset) return;
    this.selectedPreset = preset;
  }

  onImageSelect(imageUrl: string): void {
    const existingImageForCategory = Array.from(this.selectedImages).find(url => {
      const image = this.images[this.selectedPreset].find(img => img.image === url);
      return image !== undefined;
    });

    if (existingImageForCategory) {
      this.selectedImages.delete(existingImageForCategory);
    }

    const selectedImage = this.images[this.selectedPreset].find(img => img.image === imageUrl);
    if (selectedImage) {
      this.selectedImages.add(imageUrl);
      this.selectedPresetPrompt.emit({
        selectedImage: selectedImage,
        preset: this.selectedPreset
      });

      const currentIndex = this.presetList.indexOf(this.selectedPreset);
      if (currentIndex < this.presetList.length - 1) {
        setTimeout(() => {
          this.selectedPreset = this.presetList[currentIndex + 1];
        }, 200);
      }
    }
  }

  resetPresets(): void {
    this.selectedImages.clear();
    this.selectedPreset = 'Scene';
  }
}
